import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ConnectionTypeModel } from 'src/app/Model/ConnectionType.model';
import { ConnectionTypeDocumentModel } from 'src/app/Model/ConnectionTypeDocument.model';
import { ConnectionTypeDocumentFormatModel } from 'src/app/Model/ConnectionTypeDocumentFormat.model';
import { ConsultConnectionDocumentsModel } from 'src/app/Model/ConsultConnectionDocuments.model';
import { CountryModel } from 'src/app/Model/Country.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { DocumentService } from 'src/app/Services/document/Documentservice';
import { environment } from 'src/environments/environment';
import Swal from "sweetalert2";

@Component({
  selector: 'app-consult-connection-documents',
  templateUrl: './consult-connection-documents.component.html',
  styleUrls: ['./consult-connection-documents.component.css']
})

export class ConsultConnectionDocumentsComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatPaginator, { static: false }) paginatorRest: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatSort, { static: false }) sortRest: MatSort;
  @Input() public type;
  public ConnectionTypeDocumentByCode: ConnectionTypeDocumentModel = new ConnectionTypeDocumentModel();
  public UpdateBool: boolean = false
  public UpdateConnectionTypeDocument: ConnectionTypeDocumentModel = new ConnectionTypeDocumentModel();
  public Country: CountryModel[];
  public ConnectionType: ConnectionTypeModel[];
  public ConnectionTypeDocuments: ConnectionTypeDocumentModel[]
  public ConnectionTypeDocumentFormat: ConnectionTypeDocumentFormatModel = new ConnectionTypeDocumentFormatModel();
  public ConnectionTypeDocumentFormatArray: ConnectionTypeDocumentFormatModel[] = []
  public ConsultConnectionDocuments: ConsultConnectionDocumentsModel[] = []
  public ConsultConnectionDocumentsColombia: ConsultConnectionDocumentsModel[] = []
  public ConsultConnectionDocumentsRest: ConsultConnectionDocumentsModel[] = []
  public ConsultConnectionDocument: ConsultConnectionDocumentsModel
  public Request: RequestModel;
  public NameDocument: string;
  public Format: string;
  public Terms: string;
  public filterValue: string = '';
  public requestcode: string;
  public IdConnectionType: string;
  public redirectBool: boolean;
  public formSearch: FormGroup;

  public displayedColumns: string[] = ['DocumentNumber', 'ConnectionTypeName', 'CountryCode', 'DocumentName', 'DocumentType', 'DocumentConditions', 'DocumentFormat', 'Actions'];
  public dataSourceConsultConnectionDocument: MatTableDataSource<ConsultConnectionDocumentsModel>;
  public dataSourceConsultConnectionDocumentColombia: MatTableDataSource<ConsultConnectionDocumentsModel>;
  public dataSourceConsultConnectionDocumentRest: MatTableDataSource<ConsultConnectionDocumentsModel>;

  constructor(
    public dialog: MatDialog,
    private readonly Service: DocumentService,
    private readonly translate: TranslateService,
    private readonly activeRoute: ActivatedRoute,
    private readonly _builder: FormBuilder,
    private readonly activeModal: NgbActiveModal,
    private readonly lsService : SessionStorageService
  ) {
  }

  openDialogAdd() {
    this.UpdateBool = false
  }

  ngOnInit(): void {

    this.formSearch = this._builder.group({

      Search: ['', [Validators.required]],

    });

    if (this.activeRoute.snapshot.params.requestcode == undefined) {
      this.requestcode = this.lsService.getLSItem('RequestCode')
    }
    else {
      this.requestcode = this.activeRoute.snapshot.params.requestcode
    }

    this.IdConnectionType = this.lsService.getLSItem('type')
    let language = this.lsService.getLSItem('language')

    let typelang = this.IdConnectionType + ";" + language
    this.GetConnectionTypeDocuments(typelang, false)

  }

  public redirect() {

    let radicate = this.formSearch.get('Search').value;

    if (radicate) {
      window.location.replace(`Register/Main/ConsultConnectionDocuments/${radicate}`);
    } else {
      Swal.fire({
        icon: "error",
        title: this.translate.instant('ConsultConnectionDocument.Messages.1'),
        showConfirmButton: false,
        timer: 3000,
      });
    }

  }


  public DownloadFormat(url) {


    window.open(url, '_blank','noopener,noreferrer')
  }


  applyFilter(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceConsultConnectionDocumentColombia.filter = this.filterValue.trim().toLowerCase();
    if (this.dataSourceConsultConnectionDocumentColombia.paginator) {
      this.dataSourceConsultConnectionDocumentColombia.paginator.firstPage();
    }

    this.dataSourceConsultConnectionDocumentRest.filter = this.filterValue.trim().toLowerCase();
    if (this.dataSourceConsultConnectionDocumentRest.paginator) {
      this.dataSourceConsultConnectionDocumentRest.paginator.firstPage();
    }
  }
  applyFilterColombia(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceConsultConnectionDocumentColombia.filter = this.filterValue.trim().toLowerCase();
    if (this.dataSourceConsultConnectionDocumentColombia.paginator) {
      this.dataSourceConsultConnectionDocumentColombia.paginator.firstPage();
    }
  }
  applyFilterRest(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;

    this.dataSourceConsultConnectionDocumentRest.filter = this.filterValue.trim().toLowerCase();
    if (this.dataSourceConsultConnectionDocumentRest.paginator) {
      this.dataSourceConsultConnectionDocumentRest.paginator.firstPage();
    }
  }
  updateFilter() {
    this.dataSourceConsultConnectionDocumentColombia.filter = this.filterValue.trim().toLowerCase();
    if (this.dataSourceConsultConnectionDocumentColombia.paginator) {
      this.dataSourceConsultConnectionDocumentColombia.paginator.firstPage();
    }

    this.dataSourceConsultConnectionDocumentRest.filter = this.filterValue.trim().toLowerCase();
    if (this.dataSourceConsultConnectionDocumentRest.paginator) {
      this.dataSourceConsultConnectionDocumentRest.paginator.firstPage();
    }
  }

  updateFilterColombia() {
    this.dataSourceConsultConnectionDocumentColombia.filter = this.filterValue.trim().toLowerCase();
    if (this.dataSourceConsultConnectionDocumentColombia.paginator) {
      this.dataSourceConsultConnectionDocumentColombia.paginator.firstPage();
    }
  }

  updateFilterRest() {
    this.dataSourceConsultConnectionDocumentRest.filter = this.filterValue.trim().toLowerCase();
    if (this.dataSourceConsultConnectionDocumentRest.paginator) {
      this.dataSourceConsultConnectionDocumentRest.paginator.firstPage();
    }
  }

  functionFiterColombia(data, filter: string): boolean {
    return data.DocumentNumber.toLowerCase().includes(filter)
      || data.ConnectionTypeName.toLowerCase().includes(filter)
      || data.CountryCode.toLowerCase().includes(filter)
      || data.DocumentName.toLowerCase().includes(filter)
      || data.DocumentType.toLowerCase().includes(filter)
      || data.DocumentConditions.toLowerCase().includes(filter)
      || data.DocumentFormat.toLowerCase().includes(filter)
      || data.UrlDocumentFormat.toLowerCase().includes(filter);
  }

  functionFiterRest(data, filter: string): boolean {
    return data.DocumentNumber.toLowerCase().includes(filter)
      || data.ConnectionTypeName.toLowerCase().includes(filter)
      || data.CountryCode.toLowerCase().includes(filter)
      || data.DocumentName.toLowerCase().includes(filter)
      || data.DocumentType.toLowerCase().includes(filter)
      || data.DocumentConditions.toLowerCase().includes(filter)
      || data.DocumentFormat.toLowerCase().includes(filter)
      || data.UrlDocumentFormat.toLowerCase().includes(filter);
  }


  public async GetRequestByCode(noMesaje) {

    if (this.requestcode != undefined) {

      await this.Service.getRequestByCode(this.requestcode).then(async res => {
        this.Request = res;


        if (this.Request == undefined) {

          if (!noMesaje) {
            Swal.fire({
              icon: "error",
              title: this.translate.instant('ConsultConnectionDocument.Messages.2'),
              showConfirmButton: false,
              timer: 3000,
            });
          }

          this.redirectBool = true

        } else {

          if (this.Request.RequestIdentification.length != 0) {
            if (!noMesaje) {

              this.redirectBool = false

            }
          }
          else {

            if (!noMesaje) {
              Swal.fire({
                icon: "error",
                title: this.translate.instant('ConsultConnectionDocument.Messages.7'),
                showConfirmButton: false,
                timer: 3000,
              });
            }

            this.redirectBool = true
          }
        }

      });

      if (this.Request.AgencyRequiredDocument != null) {

        await this.GetConnectionTypeDocuments(this.Request, false);

      }

    }
    else {
      this.redirectBool = true

    }

  }


  public async GetConnectionTypeDocuments(Request, revised) {

    await this.Service.getGetConsultConnectionDocumentByIdConection(Request).then(res => {

      if (res != undefined) {

        this.ConnectionTypeDocuments = res

        this.ConsultConnectionDocuments = []


        res.forEach(element => {

          if (element.IsActive == true) {

            if (element.IdCountry == environment.request.countryColombia) {

              this.ConsultConnectionDocument = new ConsultConnectionDocumentsModel

              this.ConsultConnectionDocument.DocumentNumber = element.Name
              this.ConsultConnectionDocument.ConnectionTypeName = element.IdConnectionTypeNavigation.Name
              this.ConsultConnectionDocument.CountryCode = null
              this.ConsultConnectionDocument.DocumentName = element.Name
              this.ConsultConnectionDocument.DocumentType = element.ConnectionTypeDocumentFormat[0] != undefined ? element.ConnectionTypeDocumentFormat[0].Extension : ''
              this.ConsultConnectionDocument.DocumentConditions = element.ConnectionTypeDocumentFormat[0] != undefined ? element.ConnectionTypeDocumentFormat[0].Terms : ''
              this.ConsultConnectionDocument.DocumentFormat = element.ConnectionTypeDocumentFormat[0] != undefined ? element.ConnectionTypeDocumentFormat[0].Format : ''
              this.ConsultConnectionDocument.UrlDocumentFormat = element.ConnectionTypeDocumentFormat[0] != undefined ? element.ConnectionTypeDocumentFormat[0].FormatPath : undefined

              let ban = 0
              this.ConsultConnectionDocumentsColombia.forEach(element => {
                if (element.DocumentName == this.ConsultConnectionDocument.DocumentName &&
                  element.DocumentConditions == this.ConsultConnectionDocument.DocumentConditions) {
                    ban = 1;
                }
              })
              if (ban == 0) {
                this.ConsultConnectionDocumentsColombia.push(this.ConsultConnectionDocument)
              }

            } else {

              this.ConsultConnectionDocument = new ConsultConnectionDocumentsModel

              this.ConsultConnectionDocument.DocumentNumber = element.Name
              this.ConsultConnectionDocument.ConnectionTypeName = element.IdConnectionTypeNavigation.Name
              this.ConsultConnectionDocument.CountryCode = null
              this.ConsultConnectionDocument.DocumentName = element.Name
              this.ConsultConnectionDocument.DocumentType = element.ConnectionTypeDocumentFormat[0] != undefined ? element.ConnectionTypeDocumentFormat[0].Extension : ''
              this.ConsultConnectionDocument.DocumentConditions = element.ConnectionTypeDocumentFormat[0] != undefined ? element.ConnectionTypeDocumentFormat[0].Terms : ''
              this.ConsultConnectionDocument.DocumentFormat = element.ConnectionTypeDocumentFormat[0] != undefined ? element.ConnectionTypeDocumentFormat[0].Format : ''
              this.ConsultConnectionDocument.UrlDocumentFormat = element.ConnectionTypeDocumentFormat[0] != undefined ? element.ConnectionTypeDocumentFormat[0].FormatPath : undefined

              let ban = 0
              this.ConsultConnectionDocumentsRest.forEach(element => {
                if (element.DocumentName == this.ConsultConnectionDocument.DocumentName &&
                  element.DocumentConditions == this.ConsultConnectionDocument.DocumentConditions) {
                    ban = 1;
                }
              })
              if (ban == 0) {
                this.ConsultConnectionDocumentsRest.push(this.ConsultConnectionDocument)
              }
            }

          }

        });

        this.paginator._intl.itemsPerPageLabel = this.translate.instant('Request.Label.Pages');

        this.dataSourceConsultConnectionDocumentColombia = new MatTableDataSource(this.ConsultConnectionDocumentsColombia);
        this.dataSourceConsultConnectionDocumentColombia.paginator = this.paginator;
        this.dataSourceConsultConnectionDocumentColombia.sort = this.sort;
        this.dataSourceConsultConnectionDocumentColombia.filterPredicate = this.functionFiterColombia;
        this.updateFilterColombia()

        this.dataSourceConsultConnectionDocumentRest = new MatTableDataSource(this.ConsultConnectionDocumentsRest);
        this.dataSourceConsultConnectionDocumentRest.sort = this.sortRest;
        this.dataSourceConsultConnectionDocumentRest.filterPredicate = this.functionFiterRest;
        this.updateFilterRest()

      } else {

        Swal.fire({
          icon: "error",
          title: this.translate.instant('ConsultConnectionDocument.Messages.6'),
          showConfirmButton: false,
          timer: 3000,
        });

        this.redirectBool = true
      }


    });

  }

  closeModal() {
    this.activeModal.dismiss();
  }
}

